import React, { useState } from "react";
import Home from "../../pages/Home/Home";
import { AiOutlineDoubleLeft, AiOutlineDoubleRight } from "react-icons/ai";
import Menus from "../Menus/Menus";

const Layout = () => {
  const [toggle, setToggle] = useState(true);

  const handleToggle = () => {
    setToggle(!toggle);
  };

  return (
    <div className="flex">
      {/* Sidebar */}
      <aside
        className={`
          hidden md:flex flex-col fixed top-0 left-0 h-screen z-50
          bg-[#0f0f1a] border-r border-white/5
          transition-all duration-300 ease-in-out
          ${toggle ? "w-[210px]" : "w-[72px]"}
        `}
      >
      

        <Menus toggle={toggle} />
      </aside>

      {/* Main Content */}
      <main
        className={`
          flex-1 transition-all duration-300 ease-in-out
          ${toggle ? "md:ml-[210px]" : "md:ml-[72px]"}
        `}
      >
        <Home />
      </main>
    </div>
  );
};

export default Layout;